import { useContext, useEffect, useState } from "react";
import "../../../index.css";
import { Loader } from '@fluentui/react-northstar';
import { TeamsFxContext } from "../../Context";
import * as microsoftTeams from "@microsoft/teams-js";

export function Tickets() {
    const [accesstoken, setToken]= useState(null);
    const {userPrincipalName, accessToken} = useContext(TeamsFxContext);
    const [orderlist, setOrderlist] = useState(null);
    const [incidentlist, setIncidentlist] = useState(null);
    const [isLoading, setIsLoading] = useState(true);
    const reactFunctionEndpoint= process.env.REACT_APP_FUNCTION_ENDPOINT;
    const [ordersURL, setOrdersURL] = useState("");
    const [incidentsURL, setIncidentsURL] = useState("");
    const viewMoreOrdersUrl = `${reactFunctionEndpoint}/api/getSettings?type=orders`;
    const viewMoreIncidentsUrl = `${reactFunctionEndpoint}/api/getSettings?type=incidents`;

     useEffect(()=> {
            const fetchToken = async() =>{
            try{
                await microsoftTeams.app.initialize();
                const ssoToken =await microsoftTeams.authentication.getAuthToken();
                setToken(ssoToken);
            } catch (err){
                console.err("Token check error: ", err);
            }
            };
            fetchToken();
        },[]);

    /* useEffect(()=>{
    microsoftTeams.initialize();
    microsoftTeams.getContext(async (context) => {
    microsoftTeams.authentication.getAuthToken({
      successCallback: async(token) => {  
          setToken(token);
      },
      failureCallback: (error) => {
          console.error("Error getting token: ", error);
      }
    });
    });
  },[]); */

  useEffect(() => {
          if(accesstoken) {
          }
        },[ accesstoken]);


        
    useEffect(() => {
        if (userPrincipalName && accesstoken) {
            const fetchOrdersData = async () => {
                try {

                    const response = await fetch(`${reactFunctionEndpoint}/api/getServiceNowAPIData?type=orders&inputvalue=${userPrincipalName}`,
                        {
                            method: "GET",
                            headers: {
                                "Content-Type": "application/json",
                                Authorization: `Bearer ${accesstoken}`,
                            },
                        }
                    );

                    const resp_data = await response.json();
                    //console.log("Ticket orders data : ", resp_data);

                    setOrderlist(resp_data.slice(0, 5));

                    setIsLoading(false);
                } catch (error) {
                    console.error('Error fetching order details:', error);
                    setIsLoading(false);
                }
            };
            fetchOrdersData();

            const fetchIncidentData = async () => {
                try {

                    const response = await fetch(`${reactFunctionEndpoint}/api/getServiceNowAPIData?type=incidents&inputvalue=${userPrincipalName}`,
                        {
                            method: "GET",
                            headers: {
                                "Content-Type": "application/json",
                                Authorization: `Bearer ${accesstoken}`,
                            },
                        }
                    );
                    
                    const resp_incdata = await response.json();

                    //console.log ("Tickets Incident data: ", resp_incdata);

                    setIncidentlist(resp_incdata.slice(0, 5));
                    setIsLoading(false);
                } catch (error) {
                    console.error('Error fetching incident details:', error);
                    setIsLoading(false);
                }
            };
            fetchIncidentData();
        }
    }, [userPrincipalName, accesstoken]);

    useEffect(()=>{
        fetch(viewMoreOrdersUrl,
                        {
                            method: "GET",
                            headers: {
                                "Content-Type": "application/json",
                                Authorization: `Bearer ${accesstoken}`,
                            },
                        })

        .then((res)=>res.json())
        .then((data)=>{
            setOrdersURL(data.urlPath);
        })
        .catch((err)=>console.error("Error fetching env values: ", err));
    }, []);

    useEffect(()=>{
        fetch(viewMoreIncidentsUrl,
                        {
                            method: "GET",
                            headers: {
                                "Content-Type": "application/json",
                                Authorization: `Bearer ${accesstoken}`,
                            },
                        })
        .then((res)=>res.json())
        .then((data)=>{
            setIncidentsURL(data.urlPath);
        })
        .catch((err)=>console.error("Error fetching env values: ", err));
    }, []);

    return (
        <div className="flexColumn">
            <div>
                <p className="tabHeader">My Orders</p>
                {isLoading && <Loader />}
                <table className="table order-table title-table">
                    <thead>
                        <tr>
                            <th>Order Id</th>
                            <th>Title</th>
                            <th>State</th>
                            {/* <th>StateCopy</th> */}
                            <th>Updated</th>
                        </tr>
                    </thead>
                    <tbody>
                        {orderlist && orderlist.slice(0, 5).map((val, key) => (
                            <tr key={key}>
                                <td><a href={val.viewTicket} target="_blank" rel="noreferrer" >{val.OrderID}</a></td>
                                <td><p>{val.title}</p></td>
                                {(val.state === "Requested" && val.stage === "Waiting for Approval")
                                    ? <td>Waiting for Approval</td>
                                    : [
                                        (val.state === "Open" && val.stage === "Not Requested")
                                            ? <td>Not Yet Requested</td>
                                            : <td>{val.state}</td>
                                    ]
                                }
                                <td>{val.updated}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
                <a className="view_more" href={ordersURL} target="_blank" rel="noopener noreferrer">
                    View all orders
                </a>
            </div>

            <div>
                <p className="tabHeader">My Incidents</p>
                <table className="table title-table incident-table">
                    <thead>
                        <tr>
                            <th>Incident Id</th>
                            <th>Title</th>
                            <th>State</th>
                            <th>Updated</th>
                        </tr>
                    </thead>
                    <tbody>
                        {incidentlist && incidentlist.slice(0, 5).map((val, key) => (
                            <tr key={key}>
                                <td><a href={val.viewTicket} target="_blank" rel="noreferrer" >{val.incidentID}</a></td>
                                <td><p>{val.title}</p></td>
                                <td>{val.state}</td>
                                <td>{val.updated}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
                <a className="view_more" href={incidentsURL} target="_blank" rel="noreferrer"   >
                    View all incidents
                </a>
            </div>
        </div>
    );
}
